const getNameInitials = (name = "", maxInitials) => {
  return name.trim().split(/\s+/).reduce((initials, word, index) => {
    if (!maxInitials || index < maxInitials) {
      initials.push(word.charAt(0).toUpperCase());
    }
    return initials;
  }, []).join("");
};
const withQueryParams = (fetchFn) => (queryContext) => {
  const { queryKey, signal } = queryContext;
  const [, params] = queryKey;
  return fetchFn(params, signal);
};
export {
  getNameInitials,
  withQueryParams
};
